import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initAnalytics } from './lib/analytics.js'
import { hydrateProductPrices } from './config/products.js'
import { captureAttribution } from './lib/attribution.js'
import { installErrorReporter } from './lib/errorReporter.js'

installErrorReporter()
captureAttribution()
initAnalytics()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
